import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import ScrollToTopButton from "./ScrollToTopButton";

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1 pt-[80px] md:pt-[84px]">{children}</main>
    <Footer />
    <ChatWidget />
    <ScrollToTopButton />
  </div>
);

export default Layout;
